export enum LogActionEnum {
  LOGIN = 'Autenticação',
  CREATE = 'Criação',
  UPDATE = 'Atualização',
  EXECUTE = 'Execução',
  DELETE = 'Exclusão',
  EXPORT = 'Exportação',
  PRINT = 'Impressão',
}
